import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Nav from '../../components/Nav'

class Terms extends Component {
  render () {
    return (
      <div>
        <div className='container mx-auto pt-8 pb-8'>
          <Nav />
        </div>
        <div className='bg-upton-100 pt-8 pb-8'>
          <div className='flex-1 flex flex-col items-center justify-center'>
            <h2 className='text-white text-xl lg:text-6xl font-thin'>Terms and Conditions</h2>
          </div>

        </div>

        <div className='w-100 min-h-screen bg-gradient-to-b to-black from-gray-1400 relative pt-12 pb-12'>
          <div className='container text-white mx-auto p-6 text-xl terms'>
            <p>These terms and conditions apply to the <strong>Upton Priory Christmas Competition 2020</strong>.</p>
            <p>Promoter: Upton Priory Parents, Friends and Teachers Association (PTFA). The Upton Priory Christmas Competition 2020 (the "Competition") is a skill-based prize competition.</p>
            <p>Name of Responsible Person: Tom Yates, 170B Prestbury Road, Macclesfield, SK10 3BS.</p>
            <p>We will use your donations efficiently – all donations go to the Upton Priory PTFA minus any transaction costs for payments by card.</p>
            <h2 className='font-black text-2xl'>Terms and Conditions</h2>
            <h3 className='font-black text-xl'>Entering the competition:</h3>
            <ul>
              <li>This is a skill-based prize competition. To enter, participants must correctly answer a multiple-choice question before purchasing entries.</li>
              <li>Entries are not to be sold to, sold by, or bought on behalf of anyone under 16 years of age. Any entries bought by or on behalf of somebody under the age of 16 will be rejected from the draw and the money returned to them.</li>
              <li>Competition is open to residents of mainland Great Britain only (this excludes Northern Ireland, Isle of Man and Channel Islands). The named promoter is also ineligible to enter.</li>
              <li>Participation in this competition costs £1 per entry.</li>
              <li>Payment for participation in the competition can be made by credit/debit card, Google Pay or Apple Pay.</li>
              <li>Competition entries will be entered into the draw when the whole payment is received and the skill question has been answered correctly.</li>
              <li>Any entry monies received after the closing date will be treated as a donation to Upton Priory PTFA and the entries will not be entered into the draw.</li>
              <li>Upton Priory PTFA reserves the right to disqualify any entry at their absolute discretion.</li>
            </ul>
            <h3 className='font-black text-xl'>The Prize Draw:</h3>
            <ul>
              <li>The closing date for the competition is Friday 11th December 2020. The prize winners will be randomly selected in an independently supervised draw from all valid entries (i.e. those who correctly answered the skill question).</li>
              <li>Winning entries will be drawn randomly from the pool of valid entries.</li>
              <li>The result of the prize draw is final. No correspondence will be entered into.</li>
              <li>Winners will be notified by email or telephone no later than 3 weeks after the draw date. Winners' names will be published on our website within 7 days of the draw taking place.</li>
              <li>Cash prize winners will be sent their winnings by bank transfer or cheque.</li>
              <li>Upton Priory PTFA will endeavour to contact winners by email and then in writing. If no contact is made, the unclaimed prize may be returned to the competition fund.</li>
              <li>Non-cash prizes are subject to the prize suppliers' terms and conditions and any complaints or queries relating to the use of the prize should be directed to the relevant supplier of the prize.</li>
            </ul>
            <h3 className='font-black text-xl'>General:</h3>
            <ul>
              <li>This competition is operated lawfully and in accordance with applicable UK regulations.</li>
              <li>By entering this competition, participants agree to these terms and conditions.</li>
            </ul>

          </div>

        </div>
      </div>

    )
  }
};

const mapStateToProps = ({ data }) => ({
  data
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Terms))
